import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import WhatsAppFloat from "@/pages/home/components/WhatsAppFloat";
import AnnouncementBar from "@/pages/home/components/AnnouncementBar";

const TERMS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "الشروط والأحكام — متجر الإبداع AL Ebdaa",
  "description": "الشروط والأحكام لمتجر الإبداع AL Ebdaa — اقرأ شروط الاستخدام وسياسات الشراء والإرجاع والضمان قبل التسوق من متجرنا.",
  "url": `${import.meta.env.VITE_SITE_URL ?? "https://example.com"}/terms`,
  "inLanguage": "ar-SA",
  "dateModified": "2026-04-07",
  "isPartOf": {
    "@type": "WebSite",
    "name": "متجر الإبداع AL Ebdaa",
    "url": import.meta.env.VITE_SITE_URL ?? "https://example.com"
  }
};

const sections = [
  {
    id: "general",
    icon: "ri-file-text-line",
    title: "الأحكام العامة",
    items: [
      {
        subtitle: "قبول الشروط",
        text: "باستخدامك لموقع متجر الإبداع AL Ebdaa أو إتمامك لأي عملية شراء، فإنك تقر بقراءة هذه الشروط والأحكام وفهمها والموافقة عليها بالكامل. إذا كنت لا توافق على أي من هذه الشروط، يُرجى عدم استخدام الموقع.",
      },
      {
        subtitle: "التعديلات",
        text: "يحق لمتجر الإبداع تعديل هذه الشروط والأحكام في أي وقت دون إشعار مسبق. يُعدّ استمرارك في استخدام الموقع بعد نشر التعديلات موافقةً ضمنية على الشروط المحدّثة.",
      },
      {
        subtitle: "الأهلية القانونية",
        text: "يجب أن يكون المستخدم بالغاً (18 عاماً فأكثر) أو يحظى بإذن وليّ الأمر لإتمام عمليات الشراء. باستخدامك للموقع، تُقرّ بأنك تستوفي هذا الشرط.",
      },
    ],
  },
  {
    id: "orders",
    icon: "ri-shopping-bag-3-line",
    title: "الطلبات والشراء",
    items: [
      {
        subtitle: "تأكيد الطلب",
        text: "يُعدّ الطلب مؤكداً فقط بعد تواصل فريقنا معك عبر واتساب وتأكيد توفر المنتج. نحتفظ بالحق في رفض أي طلب أو إلغائه في حال عدم توفر المنتج أو وجود خطأ في السعر.",
      },
      {
        subtitle: "الأسعار",
        text: "جميع الأسعار المعروضة بالريال السعودي (SAR) وتشمل ضريبة القيمة المضافة. نحتفظ بالحق في تغيير الأسعار في أي وقت دون إشعار مسبق، غير أن الطلبات المؤكدة لن تتأثر بأي تغيير لاحق.",
      },
      {
        subtitle: "توفر المنتجات",
        text: "تُعرض المنتجات بناءً على المخزون المتاح. في حال نفاد المخزون بعد تأكيد طلبك، سنتواصل معك فوراً لإعلامك بالبدائل المتاحة أو استرداد المبلغ كاملاً.",
      },
      {
        subtitle: "الكميات",
        text: "نحتفظ بالحق في تحديد الكميات المتاحة للشراء لكل عميل، خاصةً للمنتجات ذات الطلب المرتفع أو العروض المحدودة.",
      },
    ],
  },
  {
    id: "payment",
    icon: "ri-bank-card-line",
    title: "الدفع والسداد",
    items: [
      {
        subtitle: "طرق الدفع المقبولة",
        text: "نقبل الدفع نقداً عند الاستلام، والتحويل البنكي المسبق. يجب إرسال إيصال التحويل عبر واتساب لتأكيد الطلب.",
      },
      {
        subtitle: "التحويل البنكي",
        text: "عند اختيار التحويل البنكي، يجب إتمام التحويل خلال 24 ساعة من تأكيد الطلب. في حال عدم الاستلام خلال هذه المدة، يحق لنا إلغاء الطلب تلقائياً.",
      },
      {
        subtitle: "الفواتير",
        text: "يمكنك طلب فاتورة رسمية لأي عملية شراء عبر التواصل معنا على واتساب. نلتزم بإصدار الفواتير وفق متطلبات هيئة الزكاة والضريبة والجمارك.",
      },
    ],
  },
  {
    id: "delivery",
    icon: "ri-truck-line",
    title: "التوصيل والشحن",
    items: [
      {
        subtitle: "مناطق التوصيل",
        text: "نوصّل لجميع مناطق ومدن المملكة العربية السعودية. قد تختلف مدة التوصيل حسب المنطقة الجغرافية.",
      },
      {
        subtitle: "مدة التوصيل",
        text: "تتراوح مدة التوصيل عادةً بين 2-5 أيام عمل داخل المدن الرئيسية، و3-7 أيام للمناطق الأخرى. هذه المدد تقديرية وقد تتأثر بالظروف الخارجة عن إرادتنا.",
      },
      {
        subtitle: "رسوم الشحن",
        text: "تُحسب رسوم الشحن بناءً على المنطقة الجغرافية وحجم الطلب. سيتم إبلاغك بتكلفة الشحن قبل تأكيد الطلب النهائي.",
      },
      {
        subtitle: "مخاطر الشحن",
        text: "تنتقل مسؤولية المنتج إلى العميل فور تسليمه لشركة الشحن. في حال وصول المنتج تالفاً، يُرجى التواصل معنا فوراً مع توثيق الضرر بالصور.",
      },
    ],
  },
  {
    id: "returns",
    icon: "ri-exchange-line",
    title: "الإرجاع والاستبدال",
    items: [
      {
        subtitle: "شروط الإرجاع",
        text: "يمكن إرجاع المنتجات خلال 14 يوماً من تاريخ الاستلام، شريطة أن يكون المنتج في حالته الأصلية غير المستخدمة، مع جميع ملحقاته وعبوته الأصلية.",
      },
      {
        subtitle: "المنتجات غير القابلة للإرجاع",
        text: "لا يمكن إرجاع المنتجات التي تم فتح عبوتها أو استخدامها، والألعاب الرقمية وبطاقات الاشتراك، والمنتجات المخصصة أو المعدّلة بناءً على طلب العميل.",
      },
      {
        subtitle: "إجراءات الإرجاع",
        text: "لبدء عملية الإرجاع، تواصل معنا عبر واتساب مع ذكر رقم الطلب وسبب الإرجاع. سيتواصل معك فريقنا خلال 24 ساعة لترتيب عملية الاستلام.",
      },
      {
        subtitle: "استرداد المبلغ",
        text: "يتم استرداد المبلغ خلال 5-7 أيام عمل من استلام المنتج المُرجَع والتحقق من حالته. يُستردّ المبلغ بنفس طريقة الدفع الأصلية.",
      },
    ],
  },
  {
    id: "warranty",
    icon: "ri-shield-check-line",
    title: "الضمان",
    items: [
      {
        subtitle: "مدة الضمان",
        text: "تأتي جميع أجهزة PlayStation 5 وPS4 وكمبيوتر الألعاب بضمان لمدة سنة كاملة من تاريخ الشراء. الإكسسوارات والملحقات بضمان 6 أشهر.",
      },
      {
        subtitle: "ما يشمله الضمان",
        text: "يشمل الضمان عيوب التصنيع والأعطال التقنية الناتجة عن الاستخدام الطبيعي. لا يشمل الضمان الأضرار الناتجة عن سوء الاستخدام أو الكسر أو الماء.",
      },
      {
        subtitle: "إجراءات الضمان",
        text: "لتفعيل الضمان، تواصل معنا عبر واتساب مع رقم الطلب ووصف المشكلة. سيقوم فريقنا الفني بتقييم الحالة وتحديد الإجراء المناسب.",
      },
    ],
  },
  {
    id: "intellectual",
    icon: "ri-copyright-line",
    title: "الملكية الفكرية",
    items: [
      {
        subtitle: "محتوى الموقع",
        text: "جميع المحتويات المنشورة على موقع متجر الإبداع، بما فيها النصوص والصور والشعارات والتصاميم، هي ملك حصري للمتجر ومحمية بموجب قوانين الملكية الفكرية.",
      },
      {
        subtitle: "حظر النسخ",
        text: "يُحظر نسخ أو إعادة نشر أو توزيع أي محتوى من الموقع دون الحصول على إذن كتابي مسبق من إدارة المتجر.",
      },
    ],
  },
  {
    id: "liability",
    icon: "ri-error-warning-line",
    title: "حدود المسؤولية",
    items: [
      {
        subtitle: "إخلاء المسؤولية",
        text: "لا يتحمل متجر الإبداع المسؤولية عن أي أضرار غير مباشرة أو عرضية ناتجة عن استخدام المنتجات أو الموقع، بما يتجاوز قيمة المنتج المشترى.",
      },
      {
        subtitle: "القوة القاهرة",
        text: "لا نتحمل المسؤولية عن أي تأخير أو إخفاق في تنفيذ التزاماتنا بسبب ظروف خارجة عن إرادتنا، كالكوارث الطبيعية أو القرارات الحكومية أو انقطاع الخدمات.",
      },
    ],
  },
  {
    id: "governing",
    icon: "ri-scales-3-line",
    title: "القانون الحاكم وحل النزاعات",
    items: [
      {
        subtitle: "القانون المطبّق",
        text: "تخضع هذه الشروط والأحكام لأنظمة وقوانين المملكة العربية السعودية، وتُفسَّر وفقاً لها.",
      },
      {
        subtitle: "حل النزاعات",
        text: "في حال نشوء أي نزاع، نسعى أولاً لحله وديّاً عبر التواصل المباشر. إذا تعذّر الحل الودي، يُحال النزاع إلى الجهات القضائية المختصة في المملكة العربية السعودية.",
      },
      {
        subtitle: "التواصل",
        text: "لأي استفسار حول هذه الشروط، تواصل معنا عبر واتساب على الرقم +966 54 113 8847 أو من خلال صفحة التواصل على موقعنا.",
      },
    ],
  },
];

export default function TermsPage() {
  const [barVisible, setBarVisible] = useState(true);
  const handleBarVisibility = useCallback((v: boolean) => setBarVisible(v), []);
  const [activeSection, setActiveSection] = useState("general");

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-terms";
    script.textContent = JSON.stringify(TERMS_SCHEMA);
    document.head.appendChild(script);
    document.title = "الشروط والأحكام — متجر الإبداع AL Ebdaa";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "الشروط والأحكام لمتجر الإبداع AL Ebdaa — اقرأ شروط الاستخدام وسياسات الشراء والإرجاع والضمان قبل التسوق من متجرنا لأجهزة PS5 وPS4 وكمبيوتر الألعاب."
      );
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
    return () => {
      const el = document.getElementById("schema-terms");
      if (el) el.remove();
    };
  }, []);

  const scrollToSection = (id: string) => {
    setActiveSection(id);
    const el = document.getElementById(`section-${id}`);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div dir="rtl" className="bg-[#0a0a0a] min-h-screen" style={{ fontFamily: "'Cairo', sans-serif" }}>
      <AnnouncementBar onVisibilityChange={handleBarVisibility} />
      <Navbar barVisible={barVisible} />

      <main className="pt-32 pb-24 px-4">
        <div className="max-w-6xl mx-auto">

          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-xs mb-8">
            <Link to="/" className="text-gray-600 hover:text-gray-400 transition-colors">الرئيسية</Link>
            <i className="ri-arrow-left-s-line text-gray-700"></i>
            <span className="text-gray-400">الشروط والأحكام</span>
          </div>

          {/* Header */}
          <div className="mb-12">
            <div className="inline-flex items-center gap-2 bg-amber-400/10 border border-amber-400/20 rounded-full px-4 py-1.5 mb-5">
              <i className="ri-file-text-line text-amber-400 text-sm"></i>
              <span className="text-amber-400 text-xs font-bold tracking-widest uppercase">الإطار القانوني</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-black text-white mb-4">الشروط والأحكام</h1>
            <p className="text-gray-400 text-base max-w-2xl leading-relaxed">
              يُرجى قراءة هذه الشروط والأحكام بعناية قبل استخدام موقع متجر الإبداع أو إتمام أي عملية شراء. استخدامك للموقع يعني موافقتك على هذه الشروط.
            </p>
            <div className="flex flex-wrap items-center gap-4 mt-4">
              <div className="flex items-center gap-1.5 text-gray-500 text-xs">
                <i className="ri-calendar-line text-amber-400/60"></i>
                <span>آخر تحديث: 7 أبريل 2026</span>
              </div>
              <span className="text-gray-700 text-xs">•</span>
              <div className="flex items-center gap-1.5 text-gray-500 text-xs">
                <i className="ri-map-pin-line text-amber-400/60"></i>
                <span>المملكة العربية السعودية</span>
              </div>
              <span className="text-gray-700 text-xs">•</span>
              <div className="flex items-center gap-1.5 text-gray-500 text-xs">
                <i className="ri-global-line text-amber-400/60"></i>
                <span>متجر الإبداع AL Ebdaa</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-8">

            {/* Sidebar */}
            <aside className="w-full lg:w-64 shrink-0">
              <div className="bg-[#111] border border-white/5 rounded-2xl p-4 lg:sticky lg:top-28">
                <p className="text-gray-500 text-xs font-bold uppercase tracking-widest mb-4 px-2">المحتويات</p>
                <nav className="flex flex-col gap-1">
                  {sections.map((s) => (
                    <button
                      key={s.id}
                      onClick={() => scrollToSection(s.id)}
                      className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-right transition-all cursor-pointer w-full ${
                        activeSection === s.id
                          ? "bg-amber-400/10 text-amber-400 border border-amber-400/20"
                          : "text-gray-500 hover:text-gray-300 hover:bg-white/5"
                      }`}
                    >
                      <i className={`${s.icon} text-base flex-shrink-0`}></i>
                      <span className="truncate text-right">{s.title}</span>
                    </button>
                  ))}
                </nav>

                <div className="mt-5 pt-5 border-t border-white/5 flex flex-col gap-2">
                  <p className="text-gray-600 text-xs">صفحات ذات صلة</p>
                  <Link
                    to="/privacy-policy"
                    className="flex items-center gap-2 text-gray-500 hover:text-amber-400 text-xs transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-shield-check-line text-xs"></i>
                    سياسة الخصوصية
                  </Link>
                  <Link
                    to="/about"
                    className="flex items-center gap-2 text-gray-500 hover:text-amber-400 text-xs transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-information-line text-xs"></i>
                    من نحن
                  </Link>
                </div>
              </div>
            </aside>

            {/* Content */}
            <div className="flex-1 min-w-0 flex flex-col gap-6">

              {/* Acceptance banner */}
              <div className="bg-amber-400/5 border border-amber-400/15 rounded-2xl p-5">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-400/15 rounded-xl flex-shrink-0 mt-0.5">
                    <i className="ri-information-line text-amber-400 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-amber-400 font-bold text-sm mb-1">ملاحظة مهمة</p>
                    <p className="text-gray-400 text-sm leading-relaxed">
                      باستخدامك لموقع متجر الإبداع وإتمامك لأي عملية شراء، فإنك توافق على جميع الشروط والأحكام الواردة في هذه الصفحة. إذا كان لديك أي استفسار، تواصل معنا عبر واتساب قبل إتمام الشراء.
                    </p>
                  </div>
                </div>
              </div>

              {/* Sections */}
              {sections.map((section, idx) => (
                <div
                  key={section.id}
                  id={`section-${section.id}`}
                  className="bg-[#111] border border-white/5 rounded-2xl overflow-hidden hover:border-white/10 transition-all"
                >
                  {/* Header */}
                  <div className="flex items-center gap-4 p-6 border-b border-white/5 bg-[#0f0f0f]">
                    <div className="w-10 h-10 flex items-center justify-center bg-amber-400/10 rounded-xl flex-shrink-0">
                      <i className={`${section.icon} text-amber-400 text-xl`}></i>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="text-amber-400/40 font-black text-sm">0{idx + 1}</span>
                      <h2 className="text-white font-black text-lg">{section.title}</h2>
                    </div>
                  </div>

                  {/* Items */}
                  <div className="p-6 flex flex-col gap-5">
                    {section.items.map((item, i) => (
                      <div key={i} className="flex gap-4">
                        <div className="w-1.5 h-1.5 rounded-full bg-amber-400 mt-2 flex-shrink-0" />
                        <div>
                          <h3 className="text-white font-bold text-sm mb-1.5">{item.subtitle}</h3>
                          <p className="text-gray-400 text-sm leading-relaxed">{item.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}

              {/* Contact CTA */}
              <div className="bg-[#111] border border-white/5 rounded-2xl p-6">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-green-400/10 rounded-xl flex-shrink-0">
                    <i className="ri-customer-service-2-line text-green-400 text-xl"></i>
                  </div>
                  <h2 className="text-white font-black text-lg">هل لديك استفسار؟</h2>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed mb-5">
                  إذا كان لديك أي سؤال حول هذه الشروط والأحكام أو تحتاج إلى توضيح، فريقنا متاح على مدار الساعة عبر واتساب.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="https://wa.me/966541138847"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-[#25D366]/10 hover:bg-[#25D366]/20 border border-[#25D366]/30 text-[#25D366] font-bold px-5 py-3 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-base"></i>
                    تواصل عبر واتساب
                  </a>
                  <Link
                    to="/privacy-policy"
                    className="flex items-center justify-center gap-2 border border-white/10 hover:border-amber-400/30 text-gray-400 hover:text-amber-400 font-bold px-5 py-3 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-shield-check-line text-base"></i>
                    سياسة الخصوصية
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
}